import React from 'react';
import IconTooltip from 'sg/IconTooltip/IconTooltip.react';

const TimeLimitTooltip = () => (
  <IconTooltip
    onHover
    content={
      <div>Students cannot pause the timer and must complete the assignment in one sitting.</div>
    }
    position='left'
  />
);

export default TimeLimitTooltip;
